/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { HIGHCHARTS_SANKEY_COLOURS } from '../../../../Chart.constants';
import { SankeyChartProps } from '../../SankeyChart.props';

/**
 * Parse SankeyChart props into a Highcharts format for the data options.
 */
export const getSankeyChartData = (props: SankeyChartProps): Highcharts.Options => {
  const { name, values } = props;

  const series: Array<Highcharts.SeriesOptionsType> = [
    {
      colors: HIGHCHARTS_SANKEY_COLOURS,
      data: values,
      dataLabels: {
        backgroundColor: '#3d3d3d',
        borderRadius: 4,
        style: { color: '#fff', fontSize: '12px', textOutline: 'none' },
      },
      keys: ['from', 'to', 'weight'],
      linkOpacity: 0.2,
      name,
      states: {
        hover: { linkOpacity: 0.9 },
        inactive: { linkOpacity: 0.1 },
      },
      type: 'sankey',
    },
  ];

  return {
    series,
  };
};
